import React , {useEffect, useState} from 'react';
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import '../assets/css/menu.css';
import '../assets/css/custom.css';
import '../assets/css/animate.css';
import '../assets/css/font-awesome.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/themify-icons.css';
import '../assets/css/iconmind.css';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BsBuildings } from "react-icons/bs";
import { PiUsersThree } from "react-icons/pi";
import { HiOutlineCog6Tooth } from "react-icons/hi2";
import { LiaUserCheckSolid } from "react-icons/lia";
import { AiOutlineFileText } from "react-icons/ai";
import {faSearch, faBell, faEnvelope, faTh, faFlag, faTachometer, faRocket, faFileAlt, faTable, faCertificate, faClose, faBars, faChevronRight, faLink, faCogs, faUser, faCheck, faHouseUser, faGears, faBuildingCircleCheck ,faFlagCheckered , faPersonCircleCheck, faArrowRightFromBracket, faUsers   } from '@fortawesome/free-solid-svg-icons';
// import { Link } from 'react-router-dom';
import curonext from '../assets/img/CuronextFinal.png';
import onlydots from '../assets/img/3dots.png';
import helpdeskmenu from '../assets/img/helpdeskmenu.png';
import buildingimg from '../assets/img/config-building.png';
 import { LiaUserCogSolid } from "react-icons/lia";
 
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import WifiImage from "../assets/img/wifi.png";
import WifiImageAv from "../assets/img/wifi 1.png";
import { Detector } from 'react-detect-offline';
import { Line, Circle } from 'rc-progress';
 
 
 
function Menus()
 
 
{
    const history = useNavigate();
    const [isOnline, setIsOnline] = useState(navigator.onLine); // Initialize with the current online status
    const [showOffline, setShowOffline] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [hasShownOnlineMessage, setHasShownOnlineMessage] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true); // Track if it's the first load
    console.log("internetDecter", isOnline)
    const [classname, setClassName] = useState(false)
    const [classname1, setClassName1] = useState(false)
    const [classname2, setClassName2] = useState(false)
    const [classname3, setClassName3] = useState(false)
    const [showSearch,setShowSearch] = useState(false)
    const [LogoutShow, setLogoutShow] = useState(false)
    const [UserData, setUserData] = useState("")
    const [StayLogoutShow, setStayLogoutShow] = useState(false)
    const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
    const [percent, setPercent] = useState(100);
    const [idleTime, setIdleTime] = useState(0); 
    const [WarningShow, setWarningShow] = useState(false);
    const {pathname} = useLocation()
    console.log(pathname,"ID")
    const addAnimation = (linkPosition)=>{
     
        if(linkPosition==1){
            setClassName(!classname)
            console.log(linkPosition)
        }
        if(linkPosition==2){
            setClassName1(!classname1)
            console.log(linkPosition)
        }
        if(linkPosition==3){
            setClassName2(!classname2)
            console.log(linkPosition)
        }
        if(linkPosition==4){
            setClassName3(!classname3)
            console.log(linkPosition)
        }
       
    }
 
    const idleLimit = 30; // Time limit in minutes for logout
    const warningTime = 25; // Time limit in minutes to trigger the warning

    // Reset idle time when user interacts with the page
    const resetIdleTime = () => {
        if (!WarningShow) { // Only reset if the warning has not been shown
            setIdleTime(0); // Reset idle time on user activity
            // console.log("Not Idle");
        }
    };

    // Increment the idle time counter every minute
    const startIdleTimer = () => {
        const timerId = setInterval(() => {
            setIdleTime(prevIdleTime => {
                const newIdleTime = prevIdleTime + 1; // Increment by 0.5 minutes (30 seconds)
                console.log("newIdleTime", newIdleTime)
                if (newIdleTime >= idleLimit) {
                    logout();
                    clearInterval(timerId); // Clear the interval when logging out
                    return newIdleTime; // Return the new idle time
                } else if (newIdleTime >= warningTime && !WarningShow) {
                    Noactivitylogout();
                    setWarningShow(true); // Set the flag to indicate the warning has been shown
                    setTimeLeft(300); // Reset time left for countdown to 60 seconds
                    // setPercent(100);
                }
                return newIdleTime; // Return the new idle time
            });
        }, 60000); // 30000 ms = 30 seconds

        // Return a cleanup function to clear the interval
        return () => clearInterval(timerId);
    };

    useEffect(() => {
        // Start tracking idle time
        const cleanupTimer = startIdleTimer();

        // Attach event listeners to detect user activity
        document.addEventListener('mousemove', resetIdleTime);
        document.addEventListener('keydown', resetIdleTime);
        document.addEventListener('click', resetIdleTime);
        document.addEventListener('scroll', resetIdleTime);
        document.addEventListener('touchstart', resetIdleTime);

        // Cleanup on unmount
        return () => {
            cleanupTimer(); // Clear the timer
            document.removeEventListener('mousemove', resetIdleTime);
            document.removeEventListener('keydown', resetIdleTime);
            document.removeEventListener('click', resetIdleTime);
            document.removeEventListener('scroll', resetIdleTime);
            document.removeEventListener('touchstart', resetIdleTime);
        };
    }, [WarningShow]); // Dependency array includes warningShow

    const Noactivitylogout = () => {
        console.log("Noactivitylogout");
        setStayLogoutShow(true);
    };

    const logout = () => {
        localStorage.clear(); // Clear local storage
        // Optionally navigate to a different route
        history('/'); // Navigate to the home page or login page
        // window.location.reload(); // Reload the page
    }

    useEffect(() => {
        if (WarningShow) {
            const timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    if (prevTime <= 1) {
                        clearInterval(timer);
                        // Perform logout or any other action when time is up
                        logout();
                        return 0;
                    }
                    const newTimeLeft = prevTime - 1; // Decrease time every second
                    setPercent((newTimeLeft / 300) * 100); // Update percent based on remaining time
                    return newTimeLeft;
                });
            }, 1000); // Decrease time every second

            return () => clearInterval(timer); // Cleanup on unmount
        }
    }, [WarningShow]);

    const LoginData = async() => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        console.log("userData>>>>>>>>>e", myUserData)
    }
 
    // function logout() {
    //     localStorage.clear();
    //     window.location.to = '/';
    // }
    useEffect(() => {
        LoginData();
    }, [])
 
 
    function resetNotificationPopup(){
        if(classname1){
            setClassName1(false)
        }
        if(classname){
            setClassName(false)
        }
        if(classname2){
            setClassName2(false)
        }
                if(classname3){
            setClassName3(false)
        }
       
       
    }

    useEffect(() => {
        if (!isOnline) {
            setShowOffline(true);
            setIsVisible(false); // Hide the online message if going offline

            // Set a timeout to add the visible class after 2 seconds
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 2000);

            // Cleanup the timer on component unmount or when isOnline changes
            return () => clearTimeout(timer);
        } else {
            // Reset visibility when back online
            if (!hasShownOnlineMessage && !isFirstLoad) {
                setShowOffline(false);
                setIsVisible(true); // Show the online message immediately
                setHasShownOnlineMessage(true); // Mark that we've shown the online message

                // Show the online message for 2 seconds
                const timer = setTimeout(() => {
                    setIsVisible(false);
                    setHasShownOnlineMessage(false); // Reset the flag after hiding
                }, 2000);

                return () => clearTimeout(timer);
            }
            // If it's the first load and online, just set the flag to false
            if (isFirstLoad) {
                setIsFirstLoad(false); // Mark that the first load has occurred
            }
        }
    }, [isOnline]);
 
    // function logout() {
    //     localStorage.clear();
    //  }
 
    function showSearchBar(){
        setShowSearch(true)
    }
    function hideSearchBar(){
        setShowSearch(false)
    }
    // const [classname2, setClassName2] = useState("")
    // const addAnimation2 = ()=>{
    //     setClassName2("show")
    // }
    return (
         
<>
<Navbar collapseOnSelect expand="lg" fixed='top' className="bg-body-tertiary fx_head pt-0 pb-0">
      <Container fluid>
        {UserData?.roleName == "Society HelpDesk" ?
            <Link to="/ComplaintDashboard" style={{paddingTop: "5px", paddingBottom: "5px"}}><img src={curonext} alt="homepage" className="dark-logo" style={{width: "165px",padding: '0px 0px 0px'}} /> </Link>
        :
            <Link to="/Dashboard" style={{paddingTop: "5px", paddingBottom: "5px"}}><img src={curonext} alt="homepage" className="dark-logo" style={{width: "165px",padding: '0px 0px 0px'}} /> </Link>
        }    
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto" style={{gap:"10px"}}>
            {UserData?.roleName == "Society Admin" || UserData?.roleName == "Society Operator"?
                <>
                    <Link to="/ComplaintDashboard" className={'text-black px-3 nav-link d-flex align-items-center' + (pathname == '/ComplaintDashboard' ? ' active-tab' : '')}><img src={helpdeskmenu} style={{width: 23}} className="img img-fluid" /> <span className="hide-menu pl-1"> Help Desk</span></Link>
                    <Link to="/Management" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Management' ? ' active-tab' : '')}><PiUsersThree size={"20px"}/><span className="hide-menu pl-1"> Management</span></Link>
                    <Link to="/Utility" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Utility' ? ' active-tab' : '')}><BsBuildings size={"20px"}/><span className="hide-menu pl-1"> Utility</span></Link>
                    {UserData?.roleName == "Society Operator"? null
                     :<Link to="/Approval" className={'text-black nav-link d-flex align-items-center' + (pathname == '/Approval' ? ' active-tab' : '')}> <LiaUserCheckSolid size={"20px"}/><span className="hide-menu pl-1"> Approval Central </span></Link>
                    }
                    <Link to="/SystemSetting" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/SystemSetting' ? ' active-tab' : '')}><LiaUserCogSolid size={"20px"}/><span className="hide-menu pl-1">System Setting</span></Link> 
                    <Link to="/Report" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Report' ? ' active-tab' : '')}><AiOutlineFileText size={"20px"}/><span className="hide-menu pl-1"> Reports</span></Link>
                    
                </>    
            :null}
            {UserData?.roleName == "Support Admin" ?
                <>
                    <Link to="/Configuration" className={'text-black px-3 nav-link' + (pathname=="/Configuration" ? ' active-tab' : '')}><HiOutlineCog6Tooth size={"20px"}/><span className="hide-menu"> Configuration</span></Link>
                    <Link to="/GlobalConfiguration" className={'text-black px-3 nav-link' + (pathname == '/GlobalConfiguration' ? ' active-tab' : '')}><LiaUserCogSolid size={"20px"}/><span className="hide-menu">Global Configuration</span></Link>
                </>    
            :null}
            {UserData?.roleName == "Super Admin" ?
                <>
                    <Link to="/ComplaintDashboard" className={'text-black px-3 nav-link d-flex align-items-center' + (pathname == '/ComplaintDashboard' ? ' active-tab' : '')}><img src={helpdeskmenu} style={{width: 23}} className="img img-fluid" /><span className="hide-menu pl-1"> Help Desk</span></Link>
                    <Link to="/Configuration" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Configuration' ? ' active-tab' : '')}><HiOutlineCog6Tooth size={"20px"}/><span className="hide-menu pl-1"> Configuration</span></Link>
                    <Link to="/Management" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Management' ? ' active-tab' : '')}><PiUsersThree size={"20px"}/><span className="hide-menu pl-1"> Management</span></Link>
                    <Link to="/Utility" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Utility' ? ' active-tab' : '')}><BsBuildings size={"20px"}/><span className="hide-menu pl-1"> Utility</span></Link>
                    <Link to="/Approval" className={'text-black nav-link d-flex align-items-center' + (pathname == '/Approval' ? ' active-tab' : '')}> <LiaUserCheckSolid size={"20px"}/><span className="hide-menu pl-1"> Approval Central </span></Link>
                    <Link to="/Report" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Report' ? ' active-tab' : '')}><AiOutlineFileText size={"20px"}/><span className="hide-menu pl-1"> Reports</span></Link>
                    <Link to="/GlobalConfiguration" className={'text-black  nav-link d-flex align-items-center supertAdminTabWidth' + (pathname == '/GlobalConfiguration' ? ' active-tab' : '')}><LiaUserCogSolid size={"20px"}/><span className="hide-menu pl-1">Global Configuration</span></Link>
                    {/* <Link to="/SystemSetting" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/SystemSetting' ? ' active-tab' : '')}><LiaUserCogSolid size={"20px"}/><span className="hide-menu pl-1">System Setting</span></Link> */}
                </>    
            :null}    
            {UserData?.roleName == "Society HelpDesk" ?
                <>
                    <Link to="/Management" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Management' ? ' active-tab' : '')}><PiUsersThree size={"20px"}/><span className="hide-menu pl-1"> Management</span></Link>
                    <Link to="/Report" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/Report' ? ' active-tab' : '')}><AiOutlineFileText size={"20px"}/><span className="hide-menu pl-1"> Reports</span></Link>
                    {/* <Link to="/SystemSetting" className={'text-black  nav-link d-flex align-items-center' + (pathname == '/SystemSetting' ? ' active-tab' : '')}><LiaUserCogSolid size={"20px"}/><span className="hide-menu pl-1">System Setting</span></Link> */}
                </>    
            :null}    
            {UserData?.roleName == "Super Admin" ?
             <div class="elleisemode" style={{width: 30}}>
                <img src={onlydots} className="img img-fluid" style={{top: 14, right: 14, height: 15}} />
                <div class="ellipsemodetext" style={{top: 40}}>
                    <ul>
                        <li style={{borderBottom: "none", padding: 0}}> <Link  to="/SystemSetting"><LiaUserCogSolid size={"20px"}/><span className="hide-menu pl-1"> System Settings </span></Link></li>
                        {/* <li> ABC </li>
                        <li> PQR  </li> */}
                    </ul>
                </div>
            </div>
            :null}
          </Nav>
          <Nav>
          
            <div className='pro'> 
            {!UserData?.userImage ?
                <div className='Aplha_bet'>
                    <span style={{fontWeight: 400, backgroundColor: "#dadada"}}>  {UserData?.userName?.split("")[0]} </span>
                </div>
                :
                <div className='profileImg'>
                    <img src={UserData?.userImage} style={{width:"45px", borderRadius: "30px", height: "45px"}}/>
                </div>    
            }
           <NavDropdown className='dropName navbar-light alpha_droplink' id="nav-dropdown">
            
           {/* <h6 className='buildnm'> {UserData?.buildingName}</h6>  */}
           

              <Link eventKey="4.1" to={"/Profile"}><FontAwesomeIcon icon={faUser} /> Profile </Link>
 
              

              <NavDropdown.Item eventKey="4.2" className="mt-2"  onClick={() => setLogoutShow(true)}><FontAwesomeIcon icon={faArrowRightFromBracket} /> Logout</NavDropdown.Item>
              <div style={{width: "100%", textAlign: "center", borderTop: "1px solid #dadada", paddingTop: 10}} className='mt-2'>
                {UserData?.logo ?
                    <img src={UserData?.logo} style={{width:"60px", borderRadius: "0px"}}/> :
                    <img src={buildingimg} style={{width:"50px", borderRadius: "0px"}}/>
                }
              </div>  
              <h6 className='buildnm mt-3'> {UserData?.buildingName}</h6> 
              <h6 className='buildnm mt-1'> {UserData?.addressLine1}, {UserData?.addressLine2}</h6> 
              <h6 className='buildnm mt-1'> {UserData?.city}, {UserData?.state}</h6> 
              {/* test */}
              {/* <h6 style={{marginBottom: 0, marginTop: 6, borderTop: "1px solid #dadada", paddingTop: 10, textAlign: "center"}}>Version: 3.0.8</h6> */}
              
              {/* pro */}
              <h6 style={{marginBottom: 0, marginTop: 6, borderTop: "1px solid #dadada", paddingTop: 10, textAlign: "center"}}>Version: 2.0.0</h6>
              </NavDropdown>
            
    

            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    <Modal centered show={LogoutShow} onHide={() =>
        setLogoutShow(true)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
        <Modal.Body className='p-0' style={{borderRadius: "10px", overflow: "hidden"}}>
            <div className="row px-3" id="validation">
                <div className="col-12 bg-white pt-3 pb-2">
                    <div className="FnFItem" style={{justifyContent: "flex-start"}}>
                        <div className="FnFtxt">
                            <h2> Logout </h2>
                            <h3> Are you sure you want to Logout? </h3>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            <div className='confirmation_btn pb-4 pt-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                    <div className='both_ConfrmBTN col-6'>
                        <Button variant="primary" onClick={logout}>Logout</Button>{' '}
                    </div>
                    <div className='both_ConfrmBTN col-6' onClick={() => setLogoutShow(false)} >
                        <Button variant="light"> Cancel</Button>{' '}
                    </div>
                </div>
        </Modal.Body>
    </Modal>
    <Modal centered show={StayLogoutShow} onHide={() => 
        setStayLogoutShow(true)} dialogclassName="modal-100w" className='Logoutmodal' aria-labelledby="contained-modal-title-vcenter " style={{}}>
        <Modal.Body className='important-padding-0 pt-0' style={{borderRadius: "10px", overflow: "hidden"}}>
            <div className="row" id="validation">
                <div className="col-12 bg-white pt-3 pb-2">
                {/* <Line percent={percent} strokeWidth={2} trailWidth={2} strokeColor="#8f1515" /> */}
                <Circle percent={percent} strokeWidth={3} style={{position: "absolute", width: 87, left: 89, top: 50}} trailWidth={3} strokeColor="#8f1515" /> 
                    <div className="FnFItem" style={{justifyContent: "flex-start"}}>
                        <div className="FnFtxt">
                            <h2 className='text-center'> Automatic logout in  </h2>
                            <h1 className='text-center mt-4 Font-logout-30' >{Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}</h1>
                            <h3 className='mt-4'> Would you like to continue with CuroNext? </h3>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            <div className='confirmation_btn pb-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                    <div className='both_ConfrmBTN col-6 p-0'>
                        <Button variant="primary" onClick={() => {setStayLogoutShow(false); resetIdleTime(); setWarningShow(false); setPercent(100)}} >Continue</Button>{' '}
                    </div>
                    {/* <div className='both_ConfrmBTN col-6' onClick={() => {setStayLogoutShow(false); resetIdleTime(); setWarningShow(false); setPercent(100)}}  onClick={logout}>
                        <Button variant="light"> Stay</Button>{' '}
                    </div> */}
                </div>
        </Modal.Body>
    </Modal>
    <Detector render={({ online }) => {
        setIsOnline(online);
        return (
        <div>
            {/* {showOffline && (
            <div className="OfflineStyle">
                <img src={WifiImage} className="img OfflineImg" style={{ width: "18px", marginRight: 5 }} />
                <h3 className={`Offlinediv ${isVisible ? 'visible' : ''}`}>You are offline!</h3>
            </div>
            )} */}
            {/* {!showOffline && (
            <div className="OfflineStyle">
                <img src={WifiImageAv} className="img OfflineImg" style={{ width: "18px", marginRight: 5 }} />
                <h3 style={{backgroundColor: "green"}} className={`Offlinediv ${!isVisible ? 'visible' : ''}`}>You are online!</h3>
            </div>
            )} */}
            {/* {isOnline && isVisible && (
            <div className="OfflineStyle">
                <img src={WifiImageAv} className="img OfflineImg" style={{ width: "18px", marginRight: 5 }} />
                <h3 style={{ backgroundColor: "green" }} className={`Offlinediv ${isVisible ? 'visible' : ''}`}>
                    You are online!
                </h3>
            </div>
        )} */}
        </div>
        );
    }} />
{/* <div className='card-no-border mini-sidebar upper_fixed'
 onClick={()=>resetNotificationPopup()}
 >
<header className="topbar">
            <nav className="navbar top-navbar navbar-expand-md navbar-light">
 
               
                <div className="navbar-collapse" onClick={()=>resetNotificationPopup()}>
                     
                    <ul className="navbar-nav mr-auto">
                       
                        <li className="nav-item"> <a className="nav-link nav-toggler hidden-md-up waves-effect waves-dark" to="#"><FontAwesomeIcon className="menu_bars" icon={faBars} /></a> </li>
                        <li className="nav-item hidden-sm-down"><span></span></li>
                    </ul>
                   
                    <ul className="navbar-nav my-lg-0">
 
                         
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle waves-effect waves-dark" to="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ><img src={familyAvatar4} alt="user" className="profile-pic" /></a>
                            <div className="dropdown-menu dropdown-menu-right animated flipInY">
                                <ul className="dropdown-user">
                                    <li>
                                        <div className="dw-user-box">
                                            <div className="u-img"><img src="../assets/images/users/1.jpg" alt="user" /></div>
                                            <div className="u-text">
                                                <h4>Steave Jobs</h4>
                                                <p className="text-muted">varun@gmail.com</p><a to="pages-profile.html" className="btn btn-rounded btn-danger btn-sm">View Profile</a></div>
                                        </div>
                                    </li>
                                    <li role="separator" className="divider"></li>
                                    <li><a to="#"><i className="ti-user"></i> My Profile</a></li>
                                    <li><a to="#"><i className="ti-wallet"></i> My Balance</a></li>
                                    <li><a to="#"><i className="ti-email"></i> Inbox</a></li>
                                    <li role="separator" className="divider"></li>
                                    <li><a to="#"><i className="ti-settings"></i> Account Setting</a></li>
                                    <li role="separator" className="divider"></li>
                                    <li><a to="#" onClick={logout}><i className="fa fa-power-off"></i> Logout</a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
 </header>
 
 
<aside className="left-sidebar">
    <div className="scroll-sidebar">
        <nav className="sidebar-nav">
 
                 <div className="navbar-header">
                    <a className="navbar-brand" to="#" style={{marginBottom:0,}}>
 
                       
                       <span>
                            <img src={curonext} alt="homepage" className="dark-logo" style={{width: "80%",padding: '10px 0px 5px'}} />
                       </span> </a>
                </div>
               
 
            <ul id="sidebarnav">
                <li className="nav-devider"></li>
       
                <li>
                    <Link className="has-arrow waves-effect waves-dark" to={"/Configuration"} aria-expanded="false"><FontAwesomeIcon icon={faGears} /><span className="hide-menu"> Configration</span></Link>
                   
                </li>
 
                <li>
                    <Link className="has-arrow waves-effect waves-dark" to={"/Management"} aria-expanded="false"><FontAwesomeIcon icon={faUsers} /><span className="hide-menu"> Management</span></Link>
                     
                </li>
 
                <li>
                    <a className="has-arrow waves-effect waves-dark" to="#" aria-expanded="false"><FontAwesomeIcon icon={faBuildingCircleCheck} /><span className="hide-menu"> Utility</span></a>
                 
                </li>
               
                <li>
                    <Link className="has-arrow waves-effect waves-dark" to={"/Approval"} aria-expanded="false"><FontAwesomeIcon icon={faPersonCircleCheck} /><span className="hide-menu"> Approval Central </span></Link>
                   
                </li>
                <li>
                    <a className="has-arrow waves-effect waves-dark" to="#" aria-expanded="false"><FontAwesomeIcon icon={faFlagCheckered} /><span className="hide-menu"> Reports</span></a>
                       
                </li>
            </ul>
        </nav>
 
 
 
        <div className="dropdown">
        <a className="dropdown-toggle float-right" to="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ><img src={familyAvatar4} alt="user" style={{ width: '50px',    padding: '7px 5px',}}className="profile-pic" /></a>
        <ul className="dropdown-content">
    <li><a to="OEEReport.aspx" className="color"><FontAwesomeIcon icon={faUser} /> Profile</a></li>
    <li><button  onClick={() => setLogoutShow(true)} className="color" ><FontAwesomeIcon icon={faArrowRightFromBracket} />Logout</button></li>
  </ul>
  </div>
    </div>
</aside>
 
<Modal centered show={LogoutShow} onHide={() => setLogoutShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
    <Modal.Header className="headerMDL" closeButton>
        <Modal.Title id="contained-modal-title-vcenter" centered >
            <h4 className="mb-0"> Logout confirmation </h4>
        </Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <div className="row" id="validation">
            <div className="col-12">
                <div className="FnFItem">
                 
                <div className="FnFtxt">
                    <h3> Are your Sure You want to logout? </h3>
                </div>
                </div>
                <div className='confirmation_btn'>
                <div className='both_ConfrmBTN' onClick={() => logout()}>
                    <Button variant="danger">Ok</Button>{' '}
                </div>
                <div className='both_ConfrmBTN' onClick={() => setLogoutShow(false)} >
                    <Button variant="light"> Cancel</Button>{' '}
                </div>
                </div>
            </div>
        </div>
    </Modal.Body>
</Modal>  
</div> */}
</>
)
} export default Menus;